/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommentDto } from '../../models/comment-dto';
import { CommentTargetType } from '../../models/comment-target-type';

export interface CommentsTargetTypeTargetIdGet$Json$Params {
  targetType: CommentTargetType;
  targetId: string;
}

export function commentsTargetTypeTargetIdGet$Json(http: HttpClient, rootUrl: string, params: CommentsTargetTypeTargetIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommentDto>>> {
  const rb = new RequestBuilder(rootUrl, commentsTargetTypeTargetIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('targetType', params.targetType, {});
    rb.path('targetId', params.targetId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommentDto>>;
    })
  );
}

commentsTargetTypeTargetIdGet$Json.PATH = '/comments/{targetType}/{targetId}';
